<template>
  <v-tooltip v-if="commissionMeta" top>
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" small :color="commissionMeta.color" />
    </template>
    <span>{{ commissionMeta.label }}</span>
  </v-tooltip>
  <span v-else>-</span>
</template>

<script>
const COMMISSION_STATUS_MAP = {
  1: { label: "Unpaid", color: "grey" },
  2: { label: "Partially Paid", color: "orange" },
  3: { label: "All Paid", color: "green" },
};

export default {
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    commissionMeta() {
      return COMMISSION_STATUS_MAP[this.booking.commission_status];
    },
  },
};
</script>
